import React, { Component } from 'react';

class IconEyeBlue extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="19"
                fill="none"
                viewBox="0 0 30 19"
            >
                <path
                    stroke="#2155A3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1.1 9.576s5.068-8.32 13.937-8.32c8.868 0 13.936 8.32 13.936 8.32s-5.068 8.32-13.936 8.32c-8.87 0-13.937-8.32-13.937-8.32z"
                ></path>
                <path
                    stroke="#2155A3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M18.838 9.576a3.8 3.8 0 11-7.602 0 3.8 3.8 0 017.602 0z"
                ></path>
            </svg>
        );
    }
}

export default IconEyeBlue;